import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgLog = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M2.5 15.5h11a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1ZM4.5 3.5h1M7.5 3.5h4M4.5 9.5h4M4.5 5.5h1M7.5 5.5h1M10.5 9.5h1M10.5 5.5h1M4.5 11.5h1M7.5 11.5h1M4.5 7.5h7"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLog);
export default ForwardRef;
